import React, {useEffect} from "react";
import "./processManagement.css";
import scoring_img1 from "assets/processManagement/scoring1.png";
import scoring_img2 from "assets/processManagement/scoring2.png";
import scoring_img3 from "assets/processManagement/scoring3.png";
import scoring_img4 from "assets/processManagement/scoring4.png";
import scoring_img5 from "assets/processManagement/scoring5.png";
import Meta from "utils/meta";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import TextBlock from "Component/TextBlock/textBlock";
import ImageWithTextBlock from "Component/ImageWithTextBlock/imageWithTextBlock";

const ScoringRules = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Scoring Rules | The Realtor Desk" description="" />
        <div className="sub-page--outer">
          <SubPageHeader
              title="Get Leads Scored Easily, Then Score Them Easily"
              subTitle="Realtor's intelligent lead scoring system helps you quickly identify high-quality leads, improving sales efficiency and ensuring your team focuses on the most promising opportunities."
          />
          <div className="container">
            <TextBlock
                shortTitle=""
                title="Better Real Estate Lead Scoring with Realtor CRM"
                description="Not all leads are the same. Realtor's intelligent lead scoring system evaluates each lead's level of interest, expectations, and background to help you prioritize effectively. It highlights which leads are most likely to convert, which need more attention, and which should be deprioritized, ensuring your team focuses on the right opportunities."
                textSize="large"
            />
            <ImageWithTextBlock
                shortTitle="Lead Scoring Built for Real Estate CRM"
                title="Lead Scoring Designed Specifically for Real Estate"
                description="The Realtor Desk lead scoring system provides a deeper understanding of a lead's progress in the buying journey and their level of interest. Tailored for the real estate industry, scores are assigned as buyers move through stages—from considering and evaluating to site visits and negotiations—ensuring accurate prioritization of leads."
                image={scoring_img1}
                imagePosition="right"
            />
            <ImageWithTextBlock
                shortTitle="Scoring Based on Sales Events"
                title="Understanding the Lead Journey with Lead Scoring"
                description="As a lead interacts with your sales team and engages at various touchpoints, their score increases (or decreases) based on the progression of their journey. The more touchpoints and engagement, the higher the score, providing you with a clear insight into the lead's likelihood of closing and their readiness to convert."
                image={scoring_img2}
                imagePosition="left"
            />
            <ImageWithTextBlock
                shortTitle="Scoring Based on Financial Data"
                title="Understanding the Lead's Buying Potential with Lead Scoring"
                description="Progress through the sales funnel doesn’t always guarantee a qualified lead. If a hot lead has a poor credit or CIBIL score, they may not qualify for a loan, and the sale could fall through. Realtor CRM assigns lead scores based on financial data, such as credit and CIBIL scores, giving you a more accurate prediction of the lead's potential to close and finalize the sale."
                image={scoring_img3}
                imagePosition="right"
            />
            <ImageWithTextBlock
                shortTitle="Scoring on Website Integrations"
                title="Use Website Integrations Towards Lead Scoring"
                description="In real estate, where the sales journey is often longer, customers re-engage with your website through digital campaigns and emails. Realtor CRM tracks these interactions, assigning higher lead scores as leads revisit your website or browse your collateral. This helps you prioritize engaged leads, ensuring you focus on those most likely to convert."
                image={scoring_img4}
                imagePosition="left"
            />
            <ImageWithTextBlock
                shortTitle="Intelligent Engagement Score"
                title="Leverage Lead Engagement Towards Lead Scoring"
                description="The Realtor Desk CRM combines over 200 data points to build a robust, intelligent lead score. From calls, emails, and SMS analytics to website engagement, sales inputs, sentiment analysis, and the e-commerce journey, all touchpoints are integrated to create a custom scoring process. This enables your team to focus on priority leads, with Realtor detecting and scoring the most promising opportunities."
                image={scoring_img5}
                imagePosition="right"
            />
          </div>
      </div>
    </>
  );
};

export default ScoringRules;
